import React from "react";

const CalculatorIcon = ({ ...rest }) => {
    return (
        <svg
            width="84"
            height="84"
            viewBox="0 0 84 84"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <g id="calculator">
                <path
                    id="Icon"
                    d="M61.25 22.75L22.75 61.25M29.75 36.75V22.75M22.75 29.75H36.75M47.25 54.25H61.25M27.3 73.5H56.7C62.5806 73.5 65.5208 73.5 67.7669 72.3556C69.7426 71.3489 71.3489 69.7426 72.3556 67.7669C73.5 65.5208 73.5 62.5806 73.5 56.7V27.3C73.5 21.4194 73.5 18.4792 72.3556 16.2331C71.3489 14.2574 69.7426 12.6511 67.7669 11.6444C65.5208 10.5 62.5806 10.5 56.7 10.5H27.3C21.4194 10.5 18.4792 10.5 16.2331 11.6444C14.2574 12.6511 12.6511 14.2574 11.6444 16.2331C10.5 18.4792 10.5 21.4194 10.5 27.3V56.7C10.5 62.5806 10.5 65.5208 11.6444 67.7669C12.6511 69.7426 14.2574 71.3489 16.2331 72.3556C18.4792 73.5 21.4194 73.5 27.3 73.5Z"
                    stroke="#F15D2A"
                    strokeWidth="4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </svg>
    );
};

export default CalculatorIcon;